import { render, staticRenderFns } from "./ChangePasswordPopup.vue?vue&type=template&id=2c6ab2f0&scoped=true"
import script from "./ChangePasswordPopup.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordPopup.vue?vue&type=style&index=0&id=2c6ab2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ab2f0",
  null
  
)

export default component.exports